<template>
    <section
            class="section section_type_wrapper-curtain"
            :class="{'section_status_open-widget': showSectionWidgetByRoute,}"
    >
        <section class="section section_type_widget is_new-design" id="sectionWidgetByRoute"></section>
    </section>
</template>

<script>
    export default {
        name: "SectionWidgetByRoute",
        mixins: [],
        props: {},
        components: {
        },
        data() {
            return {}
        },
        computed: {
            showSectionWidgetByRoute() {
                return this.routeMeta.sectionWidgetByRoute
            },
        },
        methods: {
        },
        updated: function() {
            //console.log('SectionWidgetByRoute updated', this.sectionWidget_component);
        },
        mounted() {
            // console.log('section_type_info', this)
        },
    }
</script>

<style scoped>

</style>